import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ConfirmationService, Message } from 'primeng/api';
import { Conta } from 'src/app/admihair/api/dto/conta';
import { ContaService } from 'src/app/admihair/service/conta.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';


@Component({
  selector: 'app-conta-listar',
  templateUrl: './conta-listar.component.html',
  styleUrls: ['./conta-listar.component.scss']
})
export class ContaListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  loading: boolean = false;
  loadingContas: boolean = false;
  listaContas: Conta[] = [];
  empresaSelecionada?: Empresa;

  constructor(
    private contaService: ContaService,
    private confirmationService: ConfirmationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    utilStorageService: UtilStorageService,) {
    super(erroService, utilStorageService)
  }



  ngOnInit(): void {
    this.loadingContas = true;
    this.verificarPermissoes();
    this.empresaSelecionada = this.getEmpresa();
    if (this.permissaoListar) {
      this.listarContas();
    }
  }

  listarContas() {
    this.contaService.listarPorEmpresa(this.empresaSelecionada?.id).subscribe({
      next: (data: Conta[]) => {
        this.loadingContas = false;
        this.listaContas = data;
      },
      error: (err: any) => {
        this.loadingContas = false;
        this.exibirMensagemErro(err);
      }
    })

  }

  excluir(id?: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.contaService.excluir(id).subscribe({
          next: () => {
            this.loading = true;
            this.exibirMensagemSucesso();
            this.listarContas();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });
      }
    });

  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  editarContaCliente(id: number) {
    this._router.navigate(["/apps/conta/editar/" + id], { relativeTo: this._activatedRoute })
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_CONTA');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_CONTA');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_CONTA');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_CONTA');
  }

}
